var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Primary",
    d: "M3.02146 3.80258C2.82618 3.63522 2.82618 3.36344 3.02146 3.19608L6.02087 0.625516C6.21614 0.458161 6.53327 0.458161 6.72854 0.625516C6.92382 0.792871 6.92382 1.06465 6.72854 1.23201L4.08219 3.5L6.72698 5.76799C6.92226 5.93535 6.92226 6.20713 6.72698 6.37448C6.53171 6.54184 6.21458 6.54184 6.01931 6.37448L3.01989 3.80392L3.02146 3.80258Z",
    fill: "#E10098"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.4baffbca45323b26eca21d2c815b4ec4.svg";
export { ForwardRef as ReactComponent };